import Model from '@ember-data/model';

import { attr, belongsTo, hasMany } from '@ember-data/model';
import { cached } from '@glimmer/tracking';
import { load } from 'ember-async-data';

import { isPointCoords } from 'rise-ui/utils/coords.js';
import { syncState } from 'rise-ui/utils/sync-state.js';

export default class LocationModel extends Model {
  @attr('string') name;
  @attr('string') description;
  @attr('string') type;
  @attr projectNames;
  @attr reclamationRegions;
  @attr unifiedRegions;
  @attr('string') sourceName;
  @attr('location-tags') tags;
  @attr('hv-datum') horizontalDatum;
  @attr('hv-datum') verticalDatum;
  @attr coordinates;
  @attr('elevation') elevation;
  @attr() states;
  @attr('string') timezone;

  @cached get latLng() {
    let result;
    const coords = this.coordinates;
    if (coords) {
      const cs = coords.coordinates;
      if (isPointCoords(coords) && cs.length === 2) {
        result = [ cs[1], cs[0] ]; // [lng, lat] -> [lat, lng]
      }
    }
    return result;
  }

  @cached get lat() {
    return this.latLng?.[0];
  }

  @cached get lng() {
    return this.latLng?.[1];
  }

  @cached get bounds() {
    return this.latLng ? undefined : L.latLngBounds(L.geoJSON(this.coordinates).getBounds());
  }

  @attr locationGeometry;
  @cached get geometry() {
    return this.locationGeometry?.locationGeometry;
  }

  @attr('date') createDate;

  @hasMany('catalog-record', { async: true, inverse: 'location' }) catalogRecords;
  @cached get asyncRecords() {
    return load(this.catalogRecords);
  }
  @cached get validCatalogRecords() {
    const validRecords = [];
    for (const record of syncState(this.asyncRecords, [])) {
      if (record.validItems.length) {
        validRecords.push(record);
      }
    }
    return validRecords;
  }

  @belongsTo('location', { async: true, inverse: null }) parentLocation;
  @hasMany('location', { async: true, inverse: null }) relatedLocations;
}
